import { useLazyQuery } from '@apollo/client'
import { GET_LESSON_EXTRA_CONTENTS } from './queries/getLessonExtraContents'
import { IGraphqlQueryProps, IOrdenationInput } from '@dtos/Pagination'

export const useGetLessonExtraContents = ({
  id,
  offset,
  limit,
}: IGraphqlQueryProps) => {
  const ordenation: IOrdenationInput = {
    by: 'createdAt',
    direction: 'ASC',
  }
  const [getMoreLessonExtraContents, { data, loading, error, variables }] =
    useLazyQuery(GET_LESSON_EXTRA_CONTENTS, {
      variables: { id, offset, limit, ordenation },
      fetchPolicy: 'cache-and-network',
    })

  return {
    getMoreLessonExtraContents,
    data,
    loading,
    error,
    variables,
  }
}
